<template>

        <div class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-md-4 mt-xl-0" >
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-0">
                Se ha enviado por WhatsApp un código de verificación al número del remitente <br><br><span class="number w-100 text-center d-block"> {{formFields.step4.senderWhatsapp[0]+formFields.step4.senderWhatsapp[1]+formFields.step4.senderWhatsapp[2]}}-{{formFields.step4.senderWhatsapp[3]+formFields.step4.senderWhatsapp[4]+formFields.step4.senderWhatsapp[5]}}-{{formFields.step4.senderWhatsapp[6]+formFields.step4.senderWhatsapp[7]+formFields.step4.senderWhatsapp[8]+formFields.step4.senderWhatsapp[9]}} </span>
            </div>
            <div class="col-xxl-8 col-10 d-flex flex-wrap justify-content-start align-content-start align-items-start">
                <div id="confirmationCode" class="col-12  d-flex justify-content-center font-3 mt-5">
                    <input ref="firstCodeInput" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" @click="checkLastInput($event)" @paste="pasteFilter($event)" @copy="disableCopy" @keyup="focusNextChrome($event, 0)"  @selectstart="disableCopy" @keydown="focusNext($event, 0)" v-model="code[0]" :type="(mobile == true) ? 'tel' : 'text'" class="inputCode" maxlength="1" type="text" value="" required="required">
                    <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  @click="checkLastInput($event)" @paste="pasteFilter($event)" @copy="disableCopy" @keyup="focusNextChrome($event, 1)" @selectstart="disableCopy" @keydown="focusNext($event, 1)" v-model="code[1]" :type="(mobile == true) ? 'tel' : 'text'" class="inputCode ms-3" maxlength="1" type="text" value="" required="required">
                    <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  @click="checkLastInput($event)" @paste="pasteFilter($event)" @copy="disableCopy" @keyup="focusNextChrome($event, 2)" @selectstart="disableCopy" @keydown="focusNext($event, 2)" v-model="code[2]" :type="(mobile == true) ? 'tel' : 'text'" class="inputCode ms-3" maxlength="1" type="text" value="" required="required">
                    <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  @click="checkLastInput($event)" @paste="pasteFilter($event)" @copy="disableCopy" ref="lastCodeInput" @keyup="focusNextChrome($event, 3)" @selectstart="disableCopy" @keydown="focusNext($event, 3)" v-model="code[3]" :type="(mobile == true) ? 'tel' : 'text'" class="inputCode ms-3" maxlength="1" type="text" value="" required="required">
                </div>

                <div class="w-100 d-flex flex-wrap justify-content-center text-start mt-4 mb-2 errMess">

                    <span v-if="codeError" class="t-xl-4 t-xxl-2 t-13 t-sm-8">El código ingresado es incorrecto</span>
                    <div class="w-100 mb-2"></div>

                    <button :class="timer<=0 ? 'active' : 'inactive pe-none' " class="loginButtonReset px-4 py-2 py-xl-3 t-xl-4 t-xxl-2 t-13 t-sm-8 mt-4 mt-xl-2" @click="sendCode()">Reenviar código</button>

                    <div v-if="timer > 0" class="w-100 d-flex justify-content-center counter mt-4 t-xl-4 t-xxl-2 t-13 t-sm-8">
                        Espere&nbsp;<span>{{Math.round(timer/1000)}}</span>s para reenviar otro código
                    </div>
                    
                </div>
            </div>
            <div class="col-xxl-8 col-10 text-start ts-2 mt-5 d-none justify-content-center">
                <button class="generalButton t-xl-12 t-xxl-8 t-35 t-sm-24 mt-0 mt-xl-5" @click="validateNextNess()">Confirmar</button>
            </div>
        </div>

</template>

<script>
export default {
    name: 'step5',
    emits:['setData', 'progress', 'showModal', 'setLoading'],
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    methods:{
        setValue(step, field, value){
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        validateNextNess(){
            if(String(this.formFields.step5.phoneConfirmed) === String(this.formFields.step4.senderWhatsapp)){
                if(this.formFields.step4.payForm == 'online'){
                    this.step(5);
                }else{
                    this.step(6);
                }
            }else{
                this.verifyLogin().then((res)=>{
                    if(!res){
                        setTimeout(()=>{
                            this.$refs.firstCodeInput.click();
                            this.$refs.firstCodeInput.focus();
                        }, 100)
                        
                        if(String(this.formFields.step5.lastPhoneCodeSended) !== String(this.formFields.step4.senderWhatsapp) && this.timer == 0){
                            this.sendCode();
                        }
                    }
                });
            }
        },
        generarUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0;
                const v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        verifyLogin(){
            return new Promise((resolve, reject) => {
                this.con.getLogin({
                    token:this.con.defToken, 
                    data:{
                        "authLog": this.tempLog,
                        "system": "giftcardSite"
                    }
                }).then((res)=>{
                    if(res.code == 200){
                        this.setValue('step5', 'phoneConfirmed', this.formFields.step4.senderWhatsapp);
                        this.validateNextNess();
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                }).catch((err)=>{resolve(false)})
            })
        },
        sendCode(){
            this.$emit('setLoading', true);
            this.codeError = false;
            this.con.processLogin({
                token:this.con.defToken, 
                data:{
                    "phone": this.formFields.step4.senderWhatsapp,
                    "authLog": this.tempLog,
                    "system": "giftcardSite"
                }
            }).then((res)=>{
                this.timer = 60000;
                localStorage.setItem('crmTimeout', 60000)
                this.countTime();
                this.$emit('setLoading', false);
                this.setValue('step5', 'lastPhoneCodeSended', this.formFields.step4.senderWhatsapp);
                this.setValue('step5', 'timer', 60);
            }).catch((err)=>{this.$emit('setLoading', false);})
        },
        step(step){
            this.$emit('progress', step);
        },
        removeAllReds(){
            setTimeout(()=>{
                document.querySelectorAll('.RedFocus').forEach((elm)=>{
                    elm.classList.remove('RedFocus')
                })
            }, 1500)
        },
        verifiedCode(){
            let code = "";
            for(let i in this.code){
                code += this.code[i]
            }
            code = code.trim();

            if(code == this.lastCodeCache){
                return false;
            }

            this.lastCodeCache = code;

            if(code.length == 4){
                this.$emit('setLoading', true);
                this.con.checkCodeValidation({
                    token:this.con.defToken, 
                    data:{
                        "phone": this.formFields.step4.senderWhatsapp,
                        "authLog": this.tempLog,
                        "system": "giftcardSite",
                        "code": code
                    }
                }).then((res)=>{
                    this.$emit('setLoading', false);
                    if(res.code==200){ // enrutamiento correcto a cuenta
                        localStorage.setItem('crmAuthServiceGiftcards', this.tempLog);
                        this.setValue('step5', 'phoneConfirmed', this.formFields.step4.senderWhatsapp);
                        localStorage.removeItem('crmTimeout');
                        this.validateNextNess();
                    }else if(res.code == 307){ // registro de nueva cuenta
                        
                    }else if(res.code == 400){ // error de codigo
                        this.codeError = true;
                        this.code = [null, null, null, null];
                        this.$refs.firstCodeInput.click();
                        document.querySelectorAll('.inputCode').forEach((e)=>{
                            e.classList.add('RedFocus');
                        })
                        this.removeAllReds();
                        setTimeout(()=>{
                            this.$refs.firstCodeInput.click();
                        }, 1500)
                    }
                }).catch((err)=>{
                    this.$emit('showModal', {type:'error', title:'Error', message:'Ha ocurrido un error, por favor intente de nuevo.'});
                })
            }
        },
        checkBrowser(){
            let ua = navigator.userAgent
            if((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) && (/Chrome/i.test(ua))){
                return false
            }else{
                return true
            }
        },
        checkLastInput(e){
            let codes = document.getElementById('confirmationCode');
            let start = null;
            for(let i=0; i <= 3; i++){
                if(codes.childNodes[i].value == null || codes.childNodes[i].value == undefined || codes.childNodes[i].value == ''){
                    start = i;
                    break;
                }
            }
            if(start != null){
                codes.childNodes[start].focus()
            }
        },
        focusNextChrome(e, i){
            if(this.loading || e.target.classList.contains('RedFocus')){
                e.preventDefault();
                return false;
            }
            if(!this.checkBrowser()){
                let val = e.target.value;
                if (/\d/.test(val)){
                    this.code[i] = String(e.target.value[e.target.value.length-1]);
                    e.target.value = e.target.value[e.target.value.length-1];
                    if(e.target.nextSibling !== undefined && e.target.nextSibling !== null){
                        e.target.nextSibling.focus();
                    }
                    this.verifiedCode();
                }else if(e.target.value == '' && i>0){
                    if(e.target.previousSibling !== undefined && e.target.previousSibling !== null){
                        e.target.previousSibling.focus();
                    }
                }else{
                    this.code[i] = '';
                    e.target.value = '';
                }
            }
        },
        focusNext(e, i){
            if(this.loading || e.target.classList.contains('RedFocus')){
                e.preventDefault();
                return false;
            }
            if(this.checkBrowser()){
                if (!e.ctrlKey){
                    e.preventDefault();
                    let keyCode = (e.keyCode ? e.keyCode : e.which);
                    
                    if (/\d/.test(e.key)){
                        this.code[i] = String(e.key)
                        if(e.target.nextSibling !== undefined && e.target.nextSibling !== null){
                            e.target.nextSibling.focus();
                        }
                        this.verifiedCode();
                    }
                    else if (keyCode == 8){
                        if((this.code[i] == null || this.code[i] == '') && i > 0){
                            e.target.previousSibling.focus();
                            this.code[i-1] = null;
                        }else{
                            this.code[i] = null;
                            if(e.target.previousSibling !== undefined && e.target.previousSibling !== null){
                                e.target.previousSibling.focus();
                            }
                        } 
                    }
                }else{
                    if(e.key != 'v'){
                        e.preventDefault();
                    }
                }
                
            }
        },
        pasteFilter(event) {
            event.preventDefault();
            let elm = document.getElementById('confirmationCode');
            let nextCodecode = event.clipboardData.getData('text').replace(/\D+/g, '');
            nextCodecode = nextCodecode.slice(0, 4);
            for(let i=0; i <= 3; i++){
                this.code[i] = null
            }
            for(let i in nextCodecode){
                this.code[i] = this.code[i] = String(nextCodecode[i]);
            }
            setTimeout(()=>{
                if(nextCodecode.length > 0){
                    elm.childNodes[nextCodecode.length-1].click();
                    elm.childNodes[nextCodecode.length-1].focus();
                }
                if(nextCodecode.length == 4){
                    this.verifiedCode();
                }
            }, 100)
            
        },
        markRed(domId){
            /**
             *
             * marca en rojo un input
             * @param domId: string, id del elemento dom asignarle el estilo
             * @change /
             * @return /
             */

             try{
                document.getElementById(domId).classList.add("RedFocus")
             }
             catch(err){}
        },
        unMarkRed(domId){
            /**
             *
             * desmarca en rojo un input
             * @param domId: string, id del elemento dom retirarle el estilo
             * @change /
             * @return /
             */

             try{
                document.getElementById(domId).classList.remove("RedFocus")
             }
             catch(err){}
        },
        countTime(internRun=false){
            if(!this.timerRunned || internRun){
                this.timerRunned = true;
                setTimeout(()=>{
                    if(!this.exit){
                        if(this.timer > 0){
                            this.timer -= 1000;
                            localStorage.setItem('crmTimeout', this.timer);
                            this.countTime(true);
                        }else{
                            this.timerRunned = false;   
                        }
                    }
                }, 1000)
            }
        },
    },
    mounted(){
        this.mobile = this.isMobile();
        this.validateNextNess();
        if(this.timer > 0){
            this.countTime();
        }
        let node = document.getElementById('masterComponent');
        node.scrollTo({
            top: 0, // Altura total del documento
            behavior: 'smooth' // Animación suave
        });
    },
    data() {
        return {
            mobile:false,
            timer:0,
            timerRunned:false,
            lastCodeCache:'',
            code:[null, null, null, null],
            codeError:false,
            timer:localStorage.crmTimeout ? Number(localStorage.crmTimeout) : 0,
            tempLog:localStorage.crmAuthServiceGiftcards ? localStorage.crmAuthServiceGiftcards : this.generarUUID()
        }
    }
}
</script>

<style scoped lang="css">
.titleOption{
    color: var(--primary);
    font-weight: 600;
}
.linkChange{
    color: var(--septagenary);
    cursor: pointer;
    font-weight: 700;
}
.linkChange:hover{
    color: var(--primary);
}

@media (max-width: 768.99px) and (min-width: 576px){
    .inputCode{
        height: 90px !important;
        width: 90px !important;
        margin: 0 10px 0 10px !important;
    }
}
@media (max-width: 1200.99px) and (min-width: 769px){
    .inputCode{
        height: 110px !important;
        width: 110px !important;
        margin: 0 10px 0 10px !important;
    }
}
@media (min-width: 1201px){
    .inputCode{
        height: 70px !important;
        width: 70px !important;
        margin: 0 10px 0 10px !important;
    }
}
.inputCode{
    height: 60px;
    width: 60px;
    margin: 0 0 0 0;
    outline: none;
    border: 4px solid var(--decagenary);
    border-radius: 7px;
    display: flex;
    justify-content: center;
    background-color: var(--tertiary);
    align-items: center;
    text-align: center;
    font-size: 25px;
    line-height: 0;
    padding-top: 3px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;   
    user-select: none;
}
.inputCode:invalid{
    background-color: var(--quartenary);
    border: 4px solid var(--quartenary);
}

.inputCode.error{
    background-color: var(--nonagenary);
    border: 4px solid var(--nonagenary);
}

.inputCode:focus{
    background-color: var(--tertiary);
    border: 4px solid var(--decagenary);
}
.number{
    color:var(--secondary)
}
.errMess{
    color: var(--secondary);
}
.loginButtonReset{
    font-weight: bold;
    background-color: var(--tertiary);
    color:var(--quartenaryText);
    outline: none;
    border: 2px solid var(--quartenaryText);
    border-radius: 12px;
}
.loginButtonReset.active{
    color:var(--tertiaryText);
    border: 2px solid var(--sexagenary);
    background-color: var(--sexagenary);
}

.loginButtonReset.inactive{
    color:var(--quartenaryText);
    border: 2px solid var(--quartenaryText);
    background-color: var(--tertiary);
    pointer-events: none;
    opacity: 0.5;
}

.loginButtonReset:hover{
    filter: contrast(0.9);
}
</style>
